<template>
  <b-popover
    v-bind="$attrs"
    :show.sync="showPopover"
    :custom-class="popoverClass"
    triggers="focus"
  >
    <slot v-bind="{ column }">
      <b-calendar
        v-if="!!column.date"
        v-model="search"
        value-as-date
        @input="applySearch"
      ></b-calendar>

      <form v-else class="p-2" @submit.prevent.stop="applySearch">
        <DatePicker
          v-if="column.datePicker"
          v-model="search"
          :range="column.datePicker.range || false"
          :type="column.datePicker.type || 'date'"
          inline
        />
        <BaseSelect
          v-else-if="!!column.options"
          v-model="search"
          :options="column.options"
          size="sm"
        >
          <template v-slot:first>
            <option :value="null" disabled>Select {{ column.label }}</option>
          </template>
        </BaseSelect>
        <BaseInput
          v-else
          v-model="search"
          :placeholder="`Search by ${column.label}`"
          size="sm"
        />

        <b-button variant="primary" size="sm" type="submit" class="mt-2"
          >Apply</b-button
        >
      </form>
    </slot>
  </b-popover>
</template>

<script>
import { defineComponent, computed, inject, ref } from '@vue/composition-api'
import DatePicker from 'vue2-datepicker'

import { BaseInput, BaseSelect } from '@components/base'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTableSearchPopover',
  components: {
    DatePicker,

    BaseInput,
    BaseSelect
  },
  props: {
    columnName: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { columns, addFilter } = inject(BaseDataTableInjectionKey)

    const column = computed(() =>
      columns.value.find((column) => column.key === props.columnName)
    )

    const showPopover = ref(false)

    const popoverClass = computed(() => {
      return Object.entries({
        'popover-daterange': !!column.value.datePicker,
        'popover-datepicker--range':
          !!column.value.datePicker && column.value.datePicker.range
      })
        .filter(([_, value]) => !!value)
        .map(([name]) => name)
        .join(' ')
    })

    const search = ref('')

    const applySearch = () => {
      if (column.value.datePicker && !!column.value.datePicker.range) {
        addFilter(column.value.key, search.value, true)
      } else {
        addFilter(column.value.key, search.value)
      }

      search.value = ''

      showPopover.value = false
    }

    return {
      showPopover,
      popoverClass,

      column,

      search,
      applySearch
    }
  }
})
</script>

<style scoped>
.mx-datepicker {
  min-width: 250px;
  display: block;
}

.mx-datepicker-range {
  min-width: 500px;
}

.mx-datepicker >>> .mx-input {
  border-radius: 4px;
  border-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}
</style>

<style>
.popover.popover-datepicker--range {
  max-width: 515px;
}
</style>
